<template>
   <div class="stage-content" :style="{ zIndex: index}">
      <div v-if="!$store.state.onIE" class="portrait-container" :class="{active : isActive}" :key="article.number">
         <img :class="[ifPrev ? 'down' : 'up']" class="background" :src="portraitBgSrc" alt="">
         <img :class="[ifPrev ? 'down' : 'up']" :src="portraitSrc" alt="">
         <img :class="[ifPrev ? 'down' : 'up']" class="multiply" :src="portraitNumberSrc" alt="">
         <img :class="[ifPrev ? 'down' : 'up']" class="multiply" :src="portraitOverlaysSrc" alt="">
         <img :class="[ifPrev ? 'down' : 'up']" :src="portraitCopySrc" alt="">
      </div>
      <div class="portrait-container flat-bg" v-else :class="[{active : isActive}, 'article-' + (index + 1)]">

      </div>
      <transition name="stage-quote">
         <StageQuote
                 v-for="(quote, index) in quotes"
                 v-if="activeQuoteIdx !== 0 && index === activeQuoteIdx && !$store.state.isPortrait"
                 :article="article"
                 :quote="quote"
                 :index="index"
                 :key="quote.heading"
         >
         </StageQuote>
      </transition>
   </div>
</template>

<script>
    import ScrollMagic from 'scrollmagic'
    import StageQuote from './StageQuote'
    import {bus, portraitIntroDuration, smController} from './../consts'
    import _ from 'lodash'

    export default {
        name: 'ArticleStageContent',
        components: {
            StageQuote
        },
        props: [
            'article',
            'index',
            'activeArticle'
        ],
        data() {
            return {
                isActive: false,
                quotes: this.article.quotes,
                color: this.article.color,
                activeQuoteIdx: 0,
                zIndex: this.index,
                mobileScene: new ScrollMagic.Scene()
            }
        },
        computed: {
            portraitBgSrc() {
                return require('./../assets/images/article_' + this.article.number + '/portrait/background.jpg');
            },
            portraitSrc() {
                return require('./../assets/images/article_' + this.article.number + '/portrait/portrait.png');
            },
            portraitCopySrc() {
                return require('./../assets/images/article_' + this.article.number + '/portrait/copy.png');
            },
            portraitNumberSrc() {
                return require('./../assets/images/article_' + this.article.number + '/portrait/number-copy.png');
            },
            portraitOverlaysSrc() {
                return require('./../assets/images/article_' + this.article.number + '/portrait/overlays.png');
            },
            ifPrev() {
              if (this.$store.state.isPortrait) {
                return false
              } else {
                if (this.$store.state.prevArticleIdx < this.$store.state.activeArticleIdx) {
                  return true
                } else {
                  return false
                }
              }
            }
        },
        methods: {
            handleReachedQuote (quoteIdx) {
                this.activeQuoteIdx = quoteIdx;
            },
            handleEndedQuote() {
                this.activeQuoteIdx = 0;
            },
            handleAnimateUp () {
                for (let i = 0; i < document.querySelectorAll('.portrait-container img').length; i++) {
                    document.querySelectorAll('.portrait-container img')[i].classList.replace('down', 'up')
                }
            },
            handleAnimateDown () {
                for (let i = 0; i < document.querySelectorAll('.portrait-container img').length; i++) {
                    document.querySelectorAll('.portrait-container img')[i].classList.replace('up', 'down')
                }
            }
        },
        mounted() {

            setTimeout(() => {
                if (!this.$store.state.isPortrait) {
                    this.isActive = true;
                }
            }, portraitIntroDuration)

            if (this.$store.state.isPortrait) {
              this.mobileScene
                  .triggerElement(this.$el.parentElement)
                  .offset(-100)
                  .on('start', (e) => {
                    e.scrollDirection === 'FORWARD' ? this.isActive = true : null;
                  })
                  .addTo(smController)
            }

            bus.$on('reachedQuote', this.handleReachedQuote);
            bus.$on('animateUp', this.handleAnimateUp);
            bus.$on('animateDown', this.handleAnimateDown);
            bus.$on('endedQuote', this.handleEndedQuote);
            // bus.$on('movePortraitUp', this.handleMovePortraitUp);
            // bus.$on('movePortraitDown', this.handleMovePortraitDown);
        },
        beforeDestroy() {
            bus.$off('reachedQuote', this.handleReachedQuote);
            bus.$off('animateUp', this.handleAnimateUp);
            bus.$off('animateDown', this.handleAnimateDown);
            bus.$off('movePortraitUp', this.handleMovePortraitUp);
            bus.$off('movePortraitDown', this.handleMovePortraitDown);
        }
    }
</script>

<style lang="scss">
   @import '../scss/the-goods';

   .stage-content {
      position : absolute;
      height   : 100%;
      width    : 100%;

      .portrait-container {
         display         : flex;
         height          : 100%;
         width           : 100%;
         align-items     : center;
         justify-content : center;
         // transform       : translateY(0vh);
         // transition      : transform .5s;

         &.flat-bg {

           @for $i from 1 through 5 {
              &.article-#{$i} {
                 background: url("./../assets/images/article-#{$i}-flat.jpg");
                 background-size: cover;
                 background-position: 50% 50%;
              }
           }
         }

         img {
            position        : absolute;
            width           : 100%;
            height          : 100%;
            object-fit      : cover;
            object-position : 50% 35%;
            opacity         : 0;

            &.multiply {
               mix-blend-mode : multiply;

               .no-blend-mode & {
                  opacity: 0.3 !important;
               }
            }

            &.up,
            &.down {
               transition : transform $default-bez .6s, opacity .3s;
            }

            @for $i from 3 through 5 {

               &.down:nth-of-type(#{$i}) {
                 transform: translateY( $i * -100px );
               }

               &.up:nth-of-type(#{$i}) {
                 transform: translateY( $i * 100px );
               }
            }

            @for $i from 3 through 5 {
               &.up:nth-child(#{$i}),
               &.down:nth-child(#{$i}) {
                  transition-delay : $i * 50ms;
               }
            }
         }

         &.active {
            img.up,
            img.down {
               transform : translateY(0px);
               opacity   : 1;
            }
         }
      }
   }

   // stageQuote component enter/leave transition classes
   .stage-quote-enter {
      transform : translateX(100%);
   }

   .stage-quote-enter-to,
   .stage-quote-leave {
      transform : translateX(0);
   }

   .stage-quote-leave-to {
      transform : translateX(-100%);
   }

</style>



// WEBPACK FOOTER //
// src/components/ArticleStageContent.vue